import styled from "styled-components";

import { device } from "../App/StyleVariables";

export const HeaderWrap = styled.header`
  margin: 0 auto;
  max-width: 58rem;
`;

export const PageTitle = styled.h1`
  margin-bottom: 2.5rem;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 120px;

  img {
    width: 100%;
  }

  @media ${device.sm} {
    margin-bottom: 3.75rem;
  }

  @media ${device.md} {
    margin-bottom: 4.25rem;
  }
`;
